import React from "react";
import { useTranslation } from "react-i18next";

const CategoryItem = ({
  category,
  showMostPopular,
  selectedCategoryIndex,
  selectCategory,
  categoriesLength,
  idx,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
  <div className="cat-tag" key={idx}>
    <span className="separator">|</span>
    {category
      ? [
          <span
            style={{
              cursor: "pointer",
            }}
            className={
              selectedCategoryIndex === idx && !showMostPopular
                ? "clipped"
                : null
            }
            onClick={() => selectCategory(idx, category)}
          >
            {category}
          </span>,
          idx + 1 === categoriesLength ? (
            <span className="separator-end">|</span>
          ) : null,
        ]
      : [
          <input
            type="text"
            placeholder={t("categoriesHeader.writeCategoryName")}
            className="trik"
          />,
          <span
            className="trik"
            style={{
              color: "var(--green)",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            +
          </span>,
        ]}
  </div>
  );
};

const SubHeader = ({
  generalCategories = [],
  showSortableMenu,
  handleSort,
  openCustomSort,
  toggleSortable,
  addCategory,
  selectedCategory,
  selectedCategoryIndex,
  selectCategory,
  showMostPopular,
  toggleMostPopular,
  showUncategorized = true,
}) => {
  const { t } = useTranslation("coaching-portal");
  const goToAllCategory = () => {
    // TODO: Fix this change on Store Categories
    //! This was removed, the idea is to handle the 'all' categories option on the selectCategory callback
  };

  const generalCategoriesModified = [...generalCategories];
  if (showUncategorized) generalCategoriesModified.push(t("categoriesHeader.uncategorized"));

  return (
    <div className="general-categories-container">
      <div className="categories-header">
        <span className="title">
          {t("categoriesHeader.categories")}
          {generalCategoriesModified && generalCategoriesModified.length
            ? ` (${generalCategoriesModified.length})`
            : null}
        </span>
        <div className="sort-container active">
          <span
            style={{
              cursor: "pointer",
            }}
            onClick={() => toggleSortable()}
          >
            <img
              className="icon-green"
              alt={t("common:filter")}
              src="/img/svg/filter.svg"
            />
            {t("categoriesHeader.sort")}
          </span>
          {showSortableMenu ? (
            <div className="sort-options">
              <span className="sort-category-title">{t("categoriesHeader.sortCategories")}</span>
              <div className="option" onClick={() => handleSort()}>
                <span>
                  <img
                    alt="asc"
                    src="/img/svg/ascending.svg"
                    className="icon-green"
                  />
                  {t("categoriesHeader.ascending")}
                </span>
              </div>
              <div className="option" onClick={() => handleSort("down")}>
                <span>
                  <img
                    alt="desc"
                    src="/img/svg/descending.svg"
                    className="icon-green"
                  />
                  {t("categoriesHeader.descending")}
                </span>
              </div>
              <div className="option last" onClick={() => openCustomSort()}>
                <span>
                  <img
                    alt={t("common:edit")}
                    src="/img/svg/edit.svg"
                    className="icon-green"
                  />
                  {t("categoriesHeader.custom")}
                </span>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="categories-container">
        <span
          onClick={() => {
            goToAllCategory();
            selectCategory("all", "All");
          }}
          style={{
            cursor: "pointer",
          }}
          className={
            selectedCategory === "All" && !showMostPopular ? "clipped" : ""
          }
        >
          {t("categoriesHeader.all")}
        </span>
        {generalCategoriesModified &&
          generalCategoriesModified.map((category, idx) => (
            <CategoryItem
              idx={idx}
              category={category}
              showMostPopular={showMostPopular}
              selectedCategoryIndex={selectedCategoryIndex}
              selectCategory={selectCategory}
              categoriesLength={generalCategoriesModified.length}
            />
          ))}

        <span className="add-category" onClick={() => addCategory()}>
          {t("categoriesHeader.addCategory")}
        </span>
      </div>
    </div>
  );
};

export default SubHeader;
